import React from "react";
import { IconButton } from "@fluentui/react";
import { useTheme } from "../theme/OAS365Theme";

/** Half of toggle width – centers the 20px button on the sidebar/content seam. */
const TOGGLE_HALF_WIDTH_PX = 10;

const SidebarCollapseToggle = ({ collapsed, onToggle }) => {
  const theme = useTheme();

  return (
    <IconButton
      iconProps={{ iconName: collapsed ? "ChevronRight" : "ChevronLeft" }}
      title={collapsed ? "Expand navigation" : "Collapse navigation"}
      ariaLabel={collapsed ? "Expand navigation" : "Collapse navigation"}
      onClick={onToggle}
      styles={{
        rootHovered: {
          background: "#E8F5E9",
        },
        rootPressed: {
          background: "#E8F5E9",
        },
        root: {
          position: "absolute",
          top: "50%",
          left: "100%",
          right: "auto",
          marginLeft: -TOGGLE_HALF_WIDTH_PX,
          transform: "translateY(-50%)",
          width: 20,
          height: 40,
          minWidth: 20,
          padding: 0,
          zIndex: 10,
          background: "#E8F5E9",
          border: `1px solid ${theme.colors.Addovation20Grey}`,
          borderRadius: collapsed ? "0 4px 4px 0" : "4px 0 0 4px",
          boxShadow: "0 1px 4px rgba(0, 0, 0, 0.12)",
          selectors: {
            ":hover": {
              background: "#E8F5E9 !important",
            },
            ":hover:enabled": {
              background: "#E8F5E9 !important",
            },
          },
        },
        icon: {
          fontSize: 10,
          color: theme.colors.addovation70Green ?? theme.colors.themeDarkColor,
        },
      }}
    />
  );
};

export default SidebarCollapseToggle;
